import { queryOptions } from '@tanstack/react-query'

import { fetchBillingSettings } from './billing-settings-api'

export const billingSettingsKeys = {
  all: ['admin-billing-settings'] as const,
  list: () => [...billingSettingsKeys.all, 'list'] as const,
}

export const billingSettingsQuery = () =>
  queryOptions({
    queryKey: billingSettingsKeys.list(),
    queryFn: ({ signal }) => fetchBillingSettings(signal),
  })
